// app/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#007abe", // Brand blue
      light: "#b3d9f8", // Light blue background
      dark: "#005f8e", // Deep blue for strong contrast
      contrastText: "#ffffff",
    },
    color: {
      dark: "#000000",
      light: "#ffffff",
    },
    secondary: {
      main: "#6c757d", // Neutral gray
      contrastText: "#ffffff",
    },
    border: {
      main: "#bdbdbd",
      contrastText: "#ffffff",
    },
    placeholder: {
      main: "#9A9C9E",
    },
    grey: {
      100: "#f8f9fa",
      200: "#e9ecef",
      300: "#dee2e6",
      400: "#ced4da",
      500: "#adb5bd",
      600: "#6c757d",
      700: "#495057",
      800: "#343a40",
      900: "#212529",
    },
    background: {
      default: "#f8f9fa",
      paper: "#ffffff",
    },
    text: {
      primary: "#212529", // Dark text for body
      secondary: "#6c757d", // Muted for labels or hint
      disabled: "#adb5bd", // Lighter gray for disabled
    },
    divider: "#e0e0e0",
    input: {
      outline: "#C5C5C4",
    },
    action: {
      hover: "#EAF5FB", // Soft blue hover
      selected: "#D6EFFF", // Slightly deeper for active selections
      disabled: "#f1f1f1",
      disabledBackground: "#f8f9fa",
      focus: "#cce6f8",
    },

    // Custom button states (optional)
    button: {
      primary: "#007abe",
      hover: "#005f8e",
      disabled: "#dee2e6",
    },

    // You can also add:
    success: {
      main: "#28a745",
      light: "#d4edda",
      dark: "#1e7e34",
      contrastText: "#ffffff",
    },
    error: {
      main: "#dc3545",
      light: "#fdf2f2",
      dark: "#bd2130",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ffc107",
      light: "#fff3cd",
      dark: "#856404",
      contrastText: "#212529",
    },
    info: {
      main: "#17a2b8",
      light: "#d1ecf1",
      dark: "#0c5460",
      contrastText: "#ffffff",
    },
  },
  typography: {
    fontFamily: `"Satoshi", sans-serif`, // Match font name from layout.jsx
  },

  components: {
    MuiRadio: {
      styleOverrides: {
        root: {
          "&.Mui-checked.Mui-disabled": {
            color: "#757575", // or use a palette color like theme.palette.grey[600]
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
          // textTransform: "none",
          // borderRadius: "12px",
          // fontWeight: 600,
          // padding: "10px 20px",
          // transition: "all 0.2s ease",
          "&.Mui-disabled": {
            backgroundColor: "rgba(95, 49, 36, 0.08)", // subtle version of your primary
            color: "rgba(0, 0, 0, 0.4)", // soft muted text
            border: "1px solid rgba(0, 0, 0, 0.08)",
            cursor: "not-allowed",
            boxShadow: "none",
          },
          "&:active": {
            transform: "translateY(0)",
            boxShadow: "none",
          },
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
          fontSize: "13.5px",
        },
        head: {
          fontSize: "12.5px",
          fontWeight: 700,
          letterSpacing: "0.05em",
          textTransform: "uppercase",
          color: "#9599a3",
          backgroundColor: "#eef1f5",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          fontFamily: `"Satoshi", sans-serif`,
        },
        label: {
          fontFamily: `"Satoshi", sans-serif`,
          "&.Mui-selected": {
            fontFamily: `"Satoshi", sans-serif`,
            fontWeight: 500, // Use Satoshi-Medium for active labels
          },
        },
      },
    },
  },
});

export default theme;
